import { Navigate, Route, Routes, useLocation } from "react-router";
import { SignInRoute } from "./SignInRoute";
import { ShareNoteRoute } from "./share/ShareNoteRoute";
import { AnimatePresence } from "framer-motion";
import { PageLayout } from "@/shared/components/layout/PageLayout";

export function PublicRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route element={<PageLayout />}>
          <Route path="/" element={<SignInRoute />} />
          <Route path="/share/notes/:noteUuid" element={<ShareNoteRoute />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}
